<template>
  <div class="ui-footer">
    <div class="ui-footer-box">
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item :title="$t('footer.cooperation.title')" name="cooperation">
          <div class="ui-footer-list-des" v-for="(item, index) in $t('footer.cooperation.list')" :key="index"><a :href="item.url" v-html="item.title"></a></div>
        </van-collapse-item>
        <van-collapse-item :title="$t('footer.product.title')" name="product">
          <div class="ui-footer-list-des" v-for="(item, index) in $t('footer.product.list')" :key="index" ><a :href="item.url" v-html="item.title"></a></div>
        </van-collapse-item>
        <van-collapse-item v-if="language !== 'en'" :title="$t('footer.legal_provisions.title')" name="legal_provisions">
          <div class="ui-footer-list-des" v-for="(item, index) in $t('footer.legal_provisions.list')" :key="index" ><a :href="item.url" v-html="item.title"></a></div>
        </van-collapse-item>
        <van-collapse-item :title="$t('footer.contactUs.title')" name="contactUs">
          <div class="code flex_1">
            <img class="code-img" :src="require('@/assets/images/code.png')" fit='fill' />
            <div class="txt textc">{{ $t('footer.code') }}</div>
          </div>
          <div>
            <div v-for="(item, index) in $t('footer.contactUs.list')" :key="index">
              <a v-if="item.url" class="ui-footer-list-des" :href="item.url" target="_blank"  v-html="item.title"></a>
              <div v-else>
                <div class="ui-footer-list-des">
                  <div class="ilblk">
                    <p class="fl">{{ item.title }}</p>
                    <div class="ilblk ">
                      <p v-for="($item, $index) in item.des" :key="$index" v-html="$item" :class="{textl: index != 0, fl: index == 0 && language == 'zh'}"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      </div>
      <div class="ui-footer-copy">
        <div class="p-5">{{ $t('footer.bottom.copy') }}</div>
        <a class="p-5" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">{{ $t('footer.bottom.ICP') }}</a>
        <a class="flex justify_content_center align_items_center ui-footer-filing p-5" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009609" target="_blank">
            <img :src="require('@/assets/images/ghs.png')" fit='fill'/>
            <p >{{ $t('footer.bottom.network') }}</p>
        </a>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      activeNames: 'contactUs'
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
.m .ui-footer{
  color: rgba(255, 255, 255, 0.6);
  background: #000000;
  // position: fixed;
  width: 100%;
  font-size: 22px;
  background-image: url(../../../assets/images/m/footer.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  .ui-footer-box{
    .van-cell {
        background: none;
        color: #ffffff;
    }
    .van-collapse-item__content {
        background: none;
        font-size: 22px;
    }
    .van-cell__title {
      font-size: 24px;
    }
    .van-collapse-item--border::after {
        border-color: rgba(255, 255, 255, 0.1);
    }
    .van-collapse-item__title--expanded::after {
        border-width: 0;
    }
    .van-hairline--top-bottom::after {
        right: calc(-50% + 30px);
        left: calc(-50% + 30px);
        border-color: rgba(255, 255, 255, 0.1);
    }
    .ui-footer-list-des{
        line-height: 1.36;
        padding: 12px 0;
        display: block;
        text-align: center;
        a {
            color: rgba(255, 255, 255, 0.6);
        }
        &:hover a {
            color: #daf3ff;
        }
    }
    .code{
      padding-top: 10px;
      text-align: center;
      line-height: 44px;
      .code-img{
        height: 160px;
        width: 160px;
        display: inline-block;
      }
      .txt {
        padding: 14px 0;
        color: #ffffff;
      }
    }
  }
  .ui-footer-copy{
    // height: 69px;
    line-height: 28px;
    font-size: 20px;
    padding: 20px 10px;
    text-align: center;
    .ui-footer-filing img{
      margin-right: 7px;
      width: 20px;
      height: 20px;
    }
    a {
      color: rgba(255, 255, 255, 0.6);
      &:hover {
        color: #daf3ff;
      }
    }
  }
}
</style>
